import { Link } from "gatsby";
import PropTypes from "prop-types";
import React, { useState } from 'react';
import Backdrop from './BackdropSection';
import appTheme from './Theme';

const Header = ({ siteTitle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const windowGlobal = typeof window !== 'undefined' && window;
  let theme = "light";

  try {
    theme = windowGlobal.localStorage.getItem("neumTheme")
  } catch {
  }

  let navClasses = 'nav-links';
  let navItemClasses = 'nav-link-item';
  let burgerClass = "burger";
  let backdropClass = "backdrop";
  if (isOpen) {
    navClasses = 'nav-links nav-active';
    navItemClasses = 'nav-link-item-active';
    burgerClass = "burger toggle";
    backdropClass = "backdrop backdrop-active";

  }

  const burgerTheme = {
    light: {
      backgroundColor: '#1b262c',
      color: '#1b262c'
    },
    dark: {
      backgroundColor: '#f2f3f7',
      color: '#f2f3f7',
    },
  }

  return (
    <header>
      <Backdrop activeClass={backdropClass} click={toggle} />
      <nav style={appTheme[theme]} className="navbar">
        <div className="nav-belt">
          <div>
            <h4>
              <Link style={appTheme[theme]} className="logo" to="/" >
              <svg className="logo-image" version="1.1" id="logo" fill="#675CE2" width="28" height="28" viewBox="0 0 100 104.6">
              <path d="M99.9,49.9c0,27.6-22.4,50-50,50c-26.7,0-49.1-21.1-49.9-47v-0.8L0.1,52c0.1-1.4,0.3-2.9,0.7-4.2v-0.1l0,0
                  c2-8.2,9.3-14.6,18.1-14.9c0.1,0,0.1,0,0.2,0h9.5v6.9H22c-8,0-14.8,6.5-14.9,14.5l0,0l0,0l0,0l0,0c0,0.1,0,0.2,0,0.3
                  c0,1.3,0.2,2.6,0.5,3.9l0,0c0.7,4.1,2.1,7.9,3.9,11.5C18.6,83.6,33.3,93.1,50,93.1c23.8,0,43.1-19.4,43.1-43.1
                  c0-19.9-13.6-36.7-32-41.7c-3.6-1-7.3-1.5-11.2-1.5c-1.9,0-3.7,0.1-5.6,0.4c-3.1,1.7-5,4.9-5.1,8.5v3.6h-0.1V47l0.1,3.2
                  c0.2,5.3,4.6,9.5,10,9.5c5.5,0,10-4.5,10-10c0-5.4-4.4-9.9-9.8-10c-0.1,0-0.1,0-0.2,0H36.4v-0.4v-6.5h12.7c9.3,0,16.9,7.6,16.9,16.9
                  s-7.6,16.9-16.9,16.9c-4.9,0-9.3-2-12.3-5.4c-0.5-0.5-0.9-1.1-1.4-1.6c-1.9-2.6-3-5.7-3.2-9.2v-0.1L32.1,47V13
                  c0-0.2,0.1-0.4,0.1-0.6c0.8-4.1,3.2-7.6,6.5-9.8l0,0c1.6-1.1,3.4-1.9,5.4-2.3c1-0.2,2.1-0.3,3.2-0.3c0.3,0,0.6,0,0.9,0
                  c0.5,0,1.1,0,1.6,0C77.5-0.1,99.9,22.4,99.9,49.9z"/>
              </svg>
              {siteTitle}
              </Link>
            </h4>
        </div>
        <ul style={appTheme[theme]} className={navClasses}>
          <li className={navItemClasses}><Link style={appTheme[theme]} to='/about'>About</Link></li>
          <li className={navItemClasses}><Link style={appTheme[theme]} to='/faq'>FAQ</Link></li>
          <li className={`${navItemClasses} nav-item-bold`} ><a rel="noreferrer" target="_blank" href="https://www.buymeacoffee.com/neum">Buy Me Coffee</a></li>
        </ul>
        <div className={burgerClass} onClick={toggle}>
          <div style={burgerTheme[theme]} className="burger-line-1"></div>
          <div style={burgerTheme[theme]} className="burger-line-2"></div>
          <div style={burgerTheme[theme]} className="burger-line-3"></div>
        </div>
        </div>
      </nav>
    </header >
  )
};

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header;
